<template>
  <h2
    class="heading-animated"
    ref="headingWrapper"
  >
    <span
      class="heading-animated__line"
      v-in-viewport
      :key="index"
      ref="headingLine"
      v-for="(line, index) in lines"
    >{{ line }}</span>
  </h2>
</template>

<script>
export default {
  props: {
    lines: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    const { headingLine, headingWrapper } = this.$refs
    const controller = new ScrollMagic.Controller()
    const scene = new ScrollMagic.Scene({
      triggerElement: headingWrapper,
      triggerHook: 'onEnter',
      duration: '90%'
    })
    const tween = new TimelineMax()

    tween
      .to(headingLine, 1, { x: '0', ease: Power1.easeOut }, 0)

    scene
      .setTween(tween)
      .addTo(controller)
  }
}
</script>

<style lang="scss" scoped>
  .heading-animated {
    @include font-style-extreme-small;
    margin-top: 88px;
    margin-bottom: 40px;
    @include media-up(sm) {
      margin-top: 133px;
      margin-bottom: 67px;
    }
    @include media-up(md) {
      margin-top: 63px;
      margin-bottom: 67px;
    }
    @include media-up(lg) {
      margin-top: 180px;
      margin-bottom: 170px;
    }
    &.opening {
      margin-top: 57px;
      margin-bottom: 38px;
      @include media-up(sm) {
        margin-top: 46px;
        margin-bottom: 75px;
      }
      @include media-up(md) {
        margin-top: 50px;
        margin-bottom: 63px;
      }
      @include media-up(lg) {
        margin-top: 93px;
        margin-bottom: 203px;
      }
    }
    &__line {
      display: block;
      position: relative;
      transform: translateX(-100%);

      &:nth-of-type(even) {
        transform: translateX(100%);
      }

      transition: opacity .4s ease-out;

      &.below-viewport:not(.in-viewport),
      &.above-viewport:not(.in-viewport) {
        opacity: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeadingAnimated.vue